'use client';

import { MAP_ID, useNaverMap } from '@/hooks/use-naver-map';
import { cn } from '@/lib/utils';
import { MarkerType } from '@/types/marker.type';

interface Props {
  markers: MarkerType[];
  zoom?: number;
  width?: string;
  height?: string;
  className?: string;
}

export default function MapDetail({
  markers,
  zoom = 15,
  width = '100%',
  height = '386px',
  className,
}: Props) {
  const { containerRef, isLoaded } = useNaverMap({ markers, zoom });

  // 높이를 className으로 직접 지정한 경우 style의 height가 덮어쓰지 않도록 한다.
  const sizeStyle = className?.includes('h-') ? { width } : { width, height };

  if (!process.env.NCP_CLIENT_ID) {
    console.warn(
      'NCP_CLIENT_ID가 설정되지 않았습니다. 지도를 표시할 수 없습니다.',
    );
    return (
      <div
        style={{ width, height }}
        className={cn(
          'desktop:h-[338px] flex flex-col items-center justify-center rounded-lg border bg-gray-100',
          className,
        )}
      >
        <div className="text-center text-gray-500">
          <div className="mb-2">🗺️</div>
          <div>지도 서비스 준비중입니다</div>
          <div className="mt-1 text-sm text-gray-400">
            API 키 설정이 필요합니다
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        ref={containerRef}
        id={MAP_ID}
        style={sizeStyle}
        className={cn('desktop:h-[338px]', className)}
      />
      {!isLoaded && (
        <div
          style={sizeStyle}
          className={cn(
            'desktop:h-[338px] flex items-center justify-center bg-gray-100',
            className,
          )}
        >
          <div className="text-gray-500">지도를 로딩중입니다...</div>
        </div>
      )}
    </>
  );
}
